import React, { useState } from "react";
import Select, { components } from "react-select";

const SelectOption = ({
  placeholder,
  value,
  options,
  onChange,
  error,
  showSearch,
  isMulti,
  extraClasses,
  required,
  isDisabled,
  name,
  filter,
  onInputChange,
  isClearable,
  checkboxes,
}) => {
  const InputOption = ({
    getStyles,
    Icon,
    isDisabled,
    isFocused,
    isSelected,
    children,
    innerProps,
    ...rest
  }) => {
    const [isActive, setIsActive] = useState(false);
    const onMouseDown = () => setIsActive(true);
    const onMouseUp = () => setIsActive(false);
    const onMouseLeave = () => setIsActive(false);

    // styles
    let bg = "transparent";
    if (isFocused) bg = "#eee";
    if (isActive) bg = "#B2D4FF";

    const style = {
      alignItems: "center",
      backgroundColor: bg,
      color: "inherit",
      display: "flex ",
    };

    // prop assignment
    const props = {
      ...innerProps,
      onMouseDown,
      onMouseUp,
      onMouseLeave,
      style,
    };

    return (
      <components.Option
        {...rest}
        isDisabled={isDisabled}
        isFocused={isFocused}
        isSelected={isSelected}
        getStyles={getStyles}
        innerProps={props}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <input type="checkbox" defaultChecked={isSelected} />
          <span>{children}</span>
        </div>
      </components.Option>
    );
  };

  return (
    <>
      {!filter && (
        <label className="font-weight-bolder font-size-sm">
          {name || placeholder}{" "}
          {required && <span style={{ color: "red" }}>*</span>}
        </label>
      )}
      <Select
        placeholder={placeholder}
        style={{
          width: "100%",
        }}
        isMulti={isMulti}
        showSearch={showSearch}
        className={`${extraClasses} ${
          error ? "invalid text-capitalize" : "text-capitalize"
        }`}
        value={value}
        options={options}
        isDisabled={isDisabled}
        onChange={onChange}
        onInputChange={onInputChange}
        isClearable={isClearable}
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        components={
          checkboxes
            ? {
                Option: InputOption,
              }
            : {}
        }
      ></Select>
      <small className="text-danger text-capitalize">{error}</small>
    </>
  );
};

export default SelectOption;
